import React from 'react';
import Spacer from '../../../../../components/presentational/Spacer';
import styled, { StylesProps } from '../../../../../lib/styles';
import { compose } from 'recompose';
import * as logging from '../../../../../server/logging';

import iconContainerBlockStyles from './IconContainer_styles';

export interface IconContainerBlockData {
  type: 'icon_container_block';
  heading: string;
  text: string;
  block_background_colour: string;
  rounded_corners: number;
  icon_size: string;
  icons: any;
}

export interface IconContainerBlockProps {
  block: IconContainerBlockData;
}

export const IconContainerBlock = ({
  block: {
    heading,
    icons,
    text,
    icon_size,
    rounded_corners,
    block_background_colour,
  },
  styles,
}) => {
  const renderIcon = (icon, index, styles) => {
    logging.silly(icon, 'IconContainerBlock::renderIcon');
    return (
      <div className={styles.icon} key={index}>
        <a href={icon.link.url} className={styles.link}>
          <img
            src={icon.icon}
            alt={icon.text}
            className={styles.iconImage}
            style={{
              backgroundColor: icon.icon_background_colour
                ? `${icon.icon_background_colour}`
                : `rgba(0,0,0,0)`,
            }}
          />
          <p>{icon.text}</p>
        </a>
      </div>
    );
  };

  logging.silly(
    { icon_size, rounded_corners, block_background_colour },
    `IconContainerBlock`
  );

  return (
    <div
      className={`IconContainerBlock ${styles.container}`}
      style={{
        backgroundColor: block_background_colour
          ? `${block_background_colour}`
          : `rgba(0,0,0,0)`,
      }}
    >
      <Spacer width={1160} space={['m', 'l']}>
        <div className={styles.panel}>
          <h2 className={styles.heading}>
            <b>{heading}</b>
          </h2>
          <p>{text}</p>
          <hr className={styles.bottomLine} />
          <div className={`iconsContainer ${styles.iconsContainer}`}>
            {icons.map((icon, index) => renderIcon(icon, index, styles))}
          </div>
        </div>
      </Spacer>
    </div>
  );
};

export default compose(styled(iconContainerBlockStyles))(IconContainerBlock);
